import { render, staticRenderFns } from "./select-goods2.vue?vue&type=template&id=23682b0a&scoped=true"
import script from "./select-goods2.vue?vue&type=script&lang=js"
export * from "./select-goods2.vue?vue&type=script&lang=js"
import style0 from "./select-goods2.vue?vue&type=style&index=0&id=23682b0a&prod&lang=scss&scoped=true"
import style1 from "./select-goods2.vue?vue&type=style&index=1&id=23682b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23682b0a",
  null
  
)

export default component.exports